// src/utils/slugify.js

export const slugify = (text) => {
    if (!text) return "";
    
    return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/ł/g, 'l')       // Ręczna zamiana małego ł
        .replace(/Ł/g, 'l')       // Ręczna zamiana dużego Ł
        .normalize('NFD')         // Rozbija resztę znaków (ą -> a + ogonek)
        .replace(/[\u0300-\u036f]/g, '') // Usuwa ogonki
        .replace(/\s+/g, '-')     // Zamienia spacje na myślniki
        .replace(/[^\w-]+/g, '')  // Usuwa znaki specjalne
        .replace(/--+/g, '-')     // Usuwa podwójne myślniki
        .replace(/^-+/, '')       // Usuwa myślnik z początku
        .replace(/-+$/, '');      // Usuwa myślnik z końca
};